import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

//新しい施設登録リクエストを開始する
export const registerFacilityRequest = () => ({
    type: ActionTypes.REGISTER_FACILITY_REQUEST
});

//新しい施設が登録されました
export const registerFacilitySuccess = (message) => ({
    type: ActionTypes.REGISTER_FACILITY_SUCCESS,
    payload: message
});

//新規施設登録の失敗
export const registerFacilityFailure = (error) => ({
    type: ActionTypes.REGISTER_FACILITY_FAILURE,
    payload: error
});

//新しい施設を登録する関数です
export const registerFacility = (payload) => {
    return async (dispatch) => {
        dispatch(registerFacilityRequest());
        try {
            if (!window.debug) {
                const accessToken = localStorage.getItem('accessToken');
                const response = await axiosInstance.post(BASE_URL + 'path=facility&type=insert-info-data', payload, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    }
                });
                let message = response.data.respons;
                if (response.data.status === 200) {
                    message = "登録しました。"; 
                }
                dispatch(registerFacilitySuccess(message));
                return { message }; 
            } else {
                const msg = "登録しました。";
                // const response = { data: { respons: msg } };
                dispatch(registerFacilitySuccess(msg));
                return { message: msg };
            }
        } catch (error) {
            const message = error.response?.data?.respons || "通信エラーが発生しました。";
            dispatch(registerFacilityFailure(message));
            return { message };
        }
    };
};


export const getManageCompanyInfoRequest = () => ({
    type: ActionTypes.FETCH_MANAGE_COMPANYINFO_REQUEST
});

export const getManageCompanyInfoSuccess = (message) => ({
    type: ActionTypes.FETCH_MANAGE_COMPANYINFO_SUCCESS,
    payload: message
});

export const getManageCompanyInfoFailure = (error) => ({
    type: ActionTypes.FETCH_MANAGE_COMPANYINFO_FAILURE,
    payload: error
});

export const getManagementCompanyInfo = () => {
    return async (dispatch) => {
        dispatch(getManageCompanyInfoRequest());
        try {
            if (!window.debug) {
                const accessToken = localStorage.getItem('accessToken');
                const response = await axiosInstance.get(BASE_URL + 'path=company&type=get-data-login', {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    }
                });
                dispatch(getManageCompanyInfoSuccess(response.data.respons));
                return response;
            }
            else {
                const data = {
                    "admin_id": 1,
                    "company_id": 1,
                    "company_name": "長谷工コーポレーション"
                }
                dispatch(getManageCompanyInfoSuccess(data));
                return data;
            }

        } catch (error) {
            dispatch(getManageCompanyInfoFailure(error.message));
        }
    };
};

